import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './header.css';

const Header = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  const navigate = useNavigate();

  const handleLogout = () => {
    if (!accessToken) {
      navigate('/');
      return;
    }

    fetch(`${baseURL}/drf-logout/`, {
      method: 'POST',
      headers: {
        Authorization: `Token ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ access_token: accessToken }),
    })
      .then((response) => {
        if (response.ok) {
          localStorage.removeItem('access_token');
          sessionStorage.removeItem('access_token');
          navigate('/');
        } else {
          console.error('Logout failed');
        }
      })
      .catch((error) => console.error('Error during logout:', error));
  };

  return (
    <nav className="tms-header navbar fixed-top">
      {/* Brand */}
      <Link className="tms-brand" to="/home">
        <div className="tms-brand-icon">⚡</div>
        <div className="tms-brand-text">
          <span className="tms-brand-title">Tmss lead management</span>
          <span className="tms-brand-sub">Dashboard &amp; Analytics</span>
        </div>
      </Link>

      {/* Right side */}
      {accessToken && (
        <div className="d-flex align-items-center">
          {/* Live status */}
          <div className="tms-status d-none d-md-flex">
            <div className="tms-status-dot" />
            <span>Live</span>
          </div>

          {/* User dropdown */}
          <div className="dropdown">
            <a
              href="#"
              className="tms-user-btn dropdown-toggle"
              id="headerUserMenu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src="tms.jpeg" alt="avatar" className="tms-avatar" />
              <span className="tms-username">TMS</span>
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end tms-dropdown-menu"
              aria-labelledby="headerUserMenu"
            >
              <li>
                <a className="dropdown-item" href="#" onClick={handleLogout}>
                  🚪 Sign out
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
